import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import { TeamNanoID } from '../../../../../../teams/teamsTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { TeamPath } from '../../../../../../teams/TeamPath';
import { IconsEnum } from '../../../../../../../assets/icons/types';
import { words } from '../../../../../../../locales/keys';

interface ThreeDStockContentCompanyLibraryEditMaterialsButtonProps {
  companyNanoId?: TeamNanoID;
  isMyLibrary?: boolean;
}

function ThreeDStockContentCompanyLibraryEditMaterialsButton({
  companyNanoId,
  isMyLibrary
}: ThreeDStockContentCompanyLibraryEditMaterialsButtonProps) {
  const { push } = useRouter();

  const handleClick = useCallback<() => void>(() => {
    push(
      isMyLibrary
        ? TeamPath.currentCompanyNewLibraryEditMaterials()
        : TeamPath.companyNewLibraryEditMaterials(companyNanoId)
    );
  }, [push, companyNanoId, isMyLibrary]);

  return (
    <PureTooltipIconButtonHelper
      className="p-2.5 rounded-md inline-flex items-center leading-6 focus:ring-base border border-gray-300 dark:border-gray-700 shadow-sm bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ease-out"
      dataGa="company-library-edit-materials-button"
      icon={IconsEnum.PENCIL}
      iconClassName="h-5 w-5"
      onClick={handleClick}
      tooltipI18nText={words.tableView}
    />
  );
}

export default ThreeDStockContentCompanyLibraryEditMaterialsButton;
